import { createDndDomain } from 'base/ui/dnd';
import { ProjectEditingActions } from '../editing_actions/project';
import {
  Page,
  pageDomain,
  PageState,
  SectionRef,
  SectionRefState,
} from '../model';

export type SectionPosition = {
  page: Page;
  index: number;
};
export type SectionSource = {
  section: SectionRefState;
  from?: SectionPosition & { mutable: SectionRef };
};
export const sectionDndDomain = createDndDomain<SectionSource, SectionPosition>(
  {
    isSelfDrop: (s, d) =>
      s.from != null &&
      s.from.page === d.page &&
      (s.from.index === d.index || s.from.index + 1 === d.index),
  },
);

export function makeDropBeforeTarget(
  page: Page | PageState,
  index: number,
  editing: ProjectEditingActions | undefined,
) {
  if (!pageDomain.isMutable(page)) return undefined;
  if (!editing) return undefined;

  return {
    mouseToDestination: () => ({ page, index }),
    processDrop: editing.dropSectionAt,
  };
}

/**
 * If you drop on the top half of a section, it will be inserted before it.
 * If you drop on the bottom half, it will be inserted after it.
 */
export function makeSectionSplitDropTarget(
  page: Page | PageState,
  index: number,
  editing: ProjectEditingActions | undefined,
) {
  if (!pageDomain.isMutable(page)) return undefined;
  if (!editing) return undefined;

  return {
    mouseToDestination: (clientX: number, clientY: number, el: HTMLElement) => {
      const box = el.getBoundingClientRect();
      const topHalf = clientY <= (box.top + box.bottom) / 2;
      const dropIndex = Math.min(
        topHalf ? index : index + 1,
        page.sections.length,
      );
      return { page, index: dropIndex };
    },
    processDrop: editing.dropSectionAt,
  };
}
